import { useState } from "react";

function Header() {
    const [activeView, setActiveView] = useState(null);
    return (
        <header className="header">
            <a
                href="#hero"
                className="link-home"
                onClick={() => setActiveView(null)}
            >
                Scarlet Tummers
            </a>
            <div className="section-links">
                <a
                    href="#projects"
                    className={`section-link ${
                        activeView === "projects" ? "active" : ""
                    }`}
                    onClick={() => setActiveView("projects")}
                >
                    Projecten
                </a>
                <a
                    href="#biography"
                    className={`section-link ${
                        activeView === "bio" ? "active" : ""
                    }`}
                    onClick={() => setActiveView("bio")}
                >
                    Biografie
                </a>

                <a
                    href="#tours"
                    className={`section-link ${
                        activeView === "tours" ? "active" : ""
                    }`}
                    onClick={() => setActiveView("tours")}
                >
                    Tourdata
                </a>

                <a
                    href="#contact"
                    className={`section-link ${
                        activeView === "contact" ? "active" : ""
                    }`}
                    onClick={() => setActiveView("contact")}
                >
                    Contact
                </a>
            </div>
        </header>
    );
}

export default Header;
